module.exports = __webpack_public_path__ + "static/media/S2N8-5.440fcec6.svg";